module.exports = __webpack_public_path__ + "static/img/login_banner.114701c9.png";